<template>
  <v-row>
    <v-col cols="8">
      <v-row>
        <line-chart
          :data="datasetCompras"
          xtitle="Fecha"
          ytitle="Unidades"
        ></line-chart>

        <!-- :title="dataset1.nombre"
          class="chart"
          :data="dataset1.data"
          xtitle="Fecha"
          :ytitle="dataset1.unidad"
          v-if="dataset1.data.length > 0" -->
      </v-row>
      <v-divider></v-divider>
      <v-spacer></v-spacer>
      <v-row>
        <!-- :title="dataset2.nombre"
          class="chart"
          :data="dataset2.data"
          v-if="dataset2.data.length > 0" -->
        <pie-chart :donut="true" :data="dataset" ytitle="Unidades"></pie-chart
      ></v-row>
    </v-col>
    <v-col cols="4"
      ><v-data-table :headers="fields" :items="prediccion"></v-data-table
    ></v-col>
  </v-row>
</template>

<script>
//getComprasSieteDias
import AlmacenService from "../../services/AlmacenService";
export default {
  props: {
    productos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      params: [],
      datasetCompras: [],
      dataset: [],
      compras: [],
      prediccion: [],
      empty: false,
      fecha1: "1890-11-11",
      fecha2: "3000-11-11",
      tab: null,
      fields: [
        {
          text: "Nombre",
          sortable: true,
          value: "producto",
          align: "center"
        },
        {
          text: "Predicción",
          sortable: true,
          value: "promedio",
          align: "center"
        }
      ]
    };
  },
  // cmputed: {
  //   formData: function() {
  //     return {
  //       productos: this.productos.data,
  //       fecha1: this.fecha1,
  //       fecha2: this.fecha2
  //     };
  //   }
  // },
  async mounted() {
    //Objeto data (fecha, valor) y nombre
    //await this.getParams();
    await this.setDataProductos();
    await this.setDataCompras();
    await this.setDataTable();

    //await this.isEmpty();
  },
  methods: {
    async getParams() {
      //id nombre unidad
      //var obj = await SensorService.getAllParams();
      //this.params = obj.data;
      this.params.push({
        id: 1,
        nombre: "Temperatura",
        unidad: "ºC"
      });
    },
    async setDataProductos() {
      //var obj1 = await AlmacenService.getComprasSieteDias();
      var obj = await AlmacenService.getProductos();
      console.log(obj.data);
      var data = [],
        res = [];

      for (let i = 0; i < obj.data.length; i++) {
        data.push(obj.data[i]);
      }
      res = data.map(objeto => Object.entries(objeto)[0]);
      this.dataset = [...res];
    },

    async setDataCompras() {
      var obj = await AlmacenService.getComprasSieteDias();
      console.log(obj.data);
      //{name: 'Workout', data: {'2017-01-01 00:00:00 -0800': 3, '2017-01-02 00:00:00 -0800': 4}},
      /**
      {
        "id": 1,
        "codigo": "XA2305",
        "fecha": "2023-05-29T00:00:00.000Z",
        "createdAt": "2023-05-22T08:12:21.000Z",
        "updatedAt": "2023-05-22T08:12:21.000Z",
        "id_producto_ecommerce": 1,
        "nombre": "Plancha a cartón comprimido 1500 x 1500",
        "unidad": "unidad",
        "veces": 2
      }
       */

      this.datasetCompras = [...obj.data];
      // this.datasetCompras = [...obj.data];
      // console.log(this.datasetCompras);
    },

    async setDataTable() {
      var obj = await AlmacenService.getPrediccion();
      console.log(obj.data);
      this.prediccion = obj.data;
    },
    async isEmpty() {
      var sensoresSinDatos = 1;
      this.dataset1.forEach(d => {
        if (d.data.length > 0) {
          sensoresSinDatos++;
        }
      });
      if (sensoresSinDatos == this.dataset1.length) this.empty = true;
      else return;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCompras.vue